import { render, staticRenderFns } from "./mobileValidate.vue?vue&type=template&id=285d13fa&scoped=true&"
import script from "./mobileValidate.vue?vue&type=script&lang=js&"
export * from "./mobileValidate.vue?vue&type=script&lang=js&"
import style0 from "./mobileValidate.vue?vue&type=style&index=0&id=285d13fa&lang=scss&scoped=true&"
import style1 from "./mobileValidate.vue?vue&type=style&index=1&id=285d13fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285d13fa",
  null
  
)

export default component.exports